import { Avatar } from 'antd';
import { Space, Typography } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { FieldLabel, FormCol, FormRow } from '../../Utils';
import { usePartyContext } from '../../../../PartyProvider';
import { getCountryLabelByCode } from 'utils/countries';
import { EMPTY } from 'views/customers/customer/utils';

type Props = {
    profilePicture: string | null;
};

const PartyDetailsView = ({ profilePicture }: Props) => {
    const { customer } = usePartyContext();

    const countryName = getCountryLabelByCode(customer.address.country);

    return (
        <div>
            <Avatar shape="square" size={80} src={profilePicture} icon={<UserOutlined />} />

            <Space size={16} direction="vertical" style={{ width: '100%', marginTop: 16 }}>
                <FormRow>
                    <FormCol>
                        <FieldLabel>Party Name</FieldLabel>
                        <Typography.Text style={{ fontWeight: 600 }}>{customer.name ?? '-'}</Typography.Text>
                    </FormCol>
                    <FormCol>
                        <FieldLabel>Reference Code</FieldLabel>
                        <Typography.Text style={{ fontWeight: 600 }}>{customer.referenceCode ?? '-'}</Typography.Text>
                    </FormCol>
                </FormRow>

                <FormRow>
                    <FormCol>
                        <FieldLabel>EORI</FieldLabel>
                        <Typography.Text style={{ fontWeight: 600 }}>{customer.eori ?? EMPTY}</Typography.Text>
                    </FormCol>
                    <FormCol>
                        <FieldLabel>VAT Number</FieldLabel>
                        <Typography.Text style={{ fontWeight: 600 }}>{customer.vatNumber ?? EMPTY}</Typography.Text>
                    </FormCol>
                </FormRow>

                <FormRow>
                    <FormCol>
                        <FieldLabel>Deferred Account Number</FieldLabel>
                        <Typography.Text style={{ fontWeight: 600 }}>
                            {customer.deferredAccountNumber ?? EMPTY}
                        </Typography.Text>
                    </FormCol>
                </FormRow>

                <FormRow>
                    <FormCol>
                        <FieldLabel>Address Line 1</FieldLabel>
                        <Typography.Text style={{ fontWeight: 600 }}>
                            {customer.address.addressLine1 ?? EMPTY}
                        </Typography.Text>
                    </FormCol>
                    <FormCol>
                        <FieldLabel>Address Line 2</FieldLabel>
                        <Typography.Text style={{ fontWeight: 600 }}>
                            {customer.address.addressLine2 ?? EMPTY}
                        </Typography.Text>
                    </FormCol>
                </FormRow>

                <FormRow>
                    <FormCol>
                        <FieldLabel>Country</FieldLabel>
                        <Typography.Text style={{ fontWeight: 600 }}>{countryName ?? EMPTY}</Typography.Text>
                    </FormCol>
                    <FormCol>
                        <div style={{ display: 'flex', gap: 32 }}>
                            <div>
                                <FieldLabel>Post Code</FieldLabel>
                                <Typography.Text style={{ fontWeight: 600 }}>
                                    {customer.address.postCode ?? EMPTY}
                                </Typography.Text>
                            </div>
                            <div>
                                <FieldLabel>City</FieldLabel>
                                <Typography.Text style={{ fontWeight: 600 }}>
                                    {customer.address.city ?? EMPTY}
                                </Typography.Text>
                            </div>
                        </div>
                    </FormCol>
                </FormRow>
            </Space>
        </div>
    );
};

export default PartyDetailsView;
